// @ts-ignore: don't complain about Vuex's misconfigured typings
import { createStore } from 'vuex'
import { auth } from "../store/auth.module"

// Set up VuexORM
import axios from 'axios'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'

VuexORM.use(VuexORMAxios, {
  axios: axios,
  baseURL: import.meta.env.VITE_API_URL,
})

import Blackout from '../models/Blackout'
import ChannelDefaultRate from '../models/ChannelDefaultRate'
import { ChannelFacility } from '../models/ChannelFacility'
import { DefaultRate } from '../models/DefaultRate'
import Event from '../models/Event'
import EventInventoryTier from '../models/EventInventoryTier'
import { EventTier } from '../models/EventTier'
import Facility from '../models/Facility'
import { Inventory } from '../models/Inventory'
import Location from '../models/Location'
import LocationHours from '../models/LocationHours'
import LocationProduct from '../models/LocationProduct'
import LocationSolution from '../models/LocationSolution'
import Organization from '../models/Organization'
import Parcs from '../models/Parcs'
import ParentSpotRate from '../models/ParentSpotRate'
import Product from '../models/Product'
import { SpotRate } from '../models/SpotRate'
import SpotHeroFlexDiscount from '../models/SpotHeroFlexDiscount'
import User from '../models/User'
import UserSolution from '../models/UserSolution'
import Venue from '../models/Venue'
import { VenueLocationProduct } from '../models/VenueLocationProduct'
import VenueTier from '../models/VenueTier'

const database = new VuexORM.Database()

database.register(Blackout)
database.register(ChannelDefaultRate)
database.register(ChannelFacility)
database.register(DefaultRate)
database.register(Event)
database.register(EventInventoryTier)
database.register(EventTier)
database.register(Facility)
database.register(Inventory)
database.register(Location)
database.register(LocationHours)
database.register(LocationProduct)
database.register(LocationSolution)
database.register(Organization)
database.register(Parcs)
database.register(ParentSpotRate)
database.register(Product)
database.register(SpotHeroFlexDiscount)
database.register(SpotRate)
database.register(User)
database.register(UserSolution)
database.register(Venue)
database.register(VenueLocationProduct)
database.register(VenueTier)

// Set up Vuex
const store = createStore({
  modules: {
    auth,
  },
  plugins: [VuexORM.install(database)],
})

export default store
